import { get, post, put, del, unwrapData } from "./apiClient";

// Re-authenticate with the logged-in user's own password to unlock Developer.
export async function verifyDeveloperPassword(password, options = {}) {
  const res = await post("/api/auth/verify-password", { ...options, body: { password } });
  return unwrapData(res);
}

export async function listApiKeys(options = {}) {
  const res = await get("/api/api-keys", options);
  const data = unwrapData(res);
  if (Array.isArray(data)) return data;
  return data?.items || data?.api_keys || [];
}

export async function createApiKey(name, options = {}) {
  const res = await post("/api/api-keys", { ...options, body: { name } });
  return unwrapData(res);
}

export async function revokeApiKey(id, options = {}) {
  const res = await del(`/api/api-keys/${encodeURIComponent(id)}`, options);
  return unwrapData(res);
}

export async function getQueueSettings(options = {}) {
  const res = await get("/api/settings/queue", options);
  return unwrapData(res);
}

export async function updateQueueSettings(payload, options = {}) {
  const res = await put("/api/settings/queue", { ...options, body: payload });
  return unwrapData(res);
}
